// Section Shopify Shopify.theme editor events

$(document)
.on('shopify:section:reorder', function(e){

  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if (Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.unload();
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

});

$(document)
.on('shopify:section:load', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];

      // Check to see if section script exists
      if (typeof Shopify.theme[triggerClass] == 'undefined') {
        // make AJAX call to load script
        Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
          Shopify.theme[triggerClass].init($(section));
        });
      } else {
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(section));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          var $block = $('.'+ triggerClass)
          var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

          // Check to see if section script exists
          if (typeof Shopify.theme[triggerClass] == 'undefined') {
            // make AJAX call to load script
            Shopify.theme.loadScript(triggerClass, blockUrl, function () {
              Shopify.theme[triggerClass].init($block);
            });
          } else {
            if (Shopify.theme[triggerClass]) {
              // console.log('Block: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  //Initialize reviews
  //Shopify.theme.productReviews.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  //Infinite scrolling
  Shopify.theme.infiniteScroll.init();

});


$(document)
.on('shopify:section:unload', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        // console.log('Section: ' + triggerClass + ' is unloaded.')
        Shopify.theme[triggerClass].unload($(section));
      } else {
        // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            // console.log('Block: ' + triggerClass + ' is unloaded.')
            Shopify.theme[triggerClass].unload($(this));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.unload($section);

  // QuantityBox
  Shopify.theme.quantityBox.unload($section);

  //Infinite scrolling
  Shopify.theme.infiniteScroll.unload($section);

});

$(document)
.on('shopify:section:select', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force show state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
      }
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  if ($('.newsletter-form__wrapper .contact-form').length > 0) {
//     Shopify.theme.newsletterAjaxForm.init();
  }

  if(isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

  if ($('.block__recommended-products').length > 0) {
    var $productPage = $('.block__recommended-products').parents('.product-page');
    Shopify.theme.jsRecommendedProducts.init($productPage);
  }

});

$(document)
.on('shopify:section:deselect', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force hide state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
      }
    }
  }

});

// Block Shopify Shopify.theme editor events

$(document)
.on('shopify:block:select', function(e){

  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  var $block = $('#shopify-section-' + blockId);

  if($('.jsFeaturedPromos').length > 0) {
    Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
  }

  if($('.jsSlideshowWithText').length > 0) {
    Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
  }

  if ($('.jsSlideshowClassic').length > 0) {
    Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
  }

  if($('.jsTestimonials').length > 0) {
    Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
  }

  // Sidebar collection multi-tag filter
  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle-icon="closed"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();
});

$(document)
.on('shopify:block:deselect', function(e){

  var $block = $('#shopify-section-' + e.detail.blockId);

  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle-icon="open"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
    }
  }

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {

  var $jsSections = $('.shopify-section[class*=js]');

  // Loop through sections with js classes and load them in
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        var triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(this));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }

      }
    }
  });

  var resizeTimer;

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      Shopify.theme.objectFitImages.calculateAspectRatio();

      if (!isScreenSizeLarge()){
        // When 798 or less
        Shopify.theme.mobileMenu.init();

      } else {

        // When larger than 798
        Shopify.theme.mobileMenu.unload();

        // Swatches
        if(Shopify.theme_settings.product_form_style == 'swatches') {
          Shopify.theme.thumbnail.enableSwatches();
        }

        if ($('.product-template--image-scroll').find('.sticky-product-scroll').length) {
          Shopify.theme.jsProduct.enableStickyScroll($('.product-template--image-scroll').find('.sticky-product-scroll'));
        };
      }

    }, 250);
    Ffheader();
  });
  
  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // QuantityBox
  Shopify.theme.quantityBox.init();

  /* Show secondary image on hover */
  if (Shopify.theme_settings.show_secondary_image == true) {
    Shopify.theme.thumbnail.showVariantImage();
  }

  // Collection swatches
  if (Shopify.theme_settings.show_collection_swatches) {
    Shopify.theme.thumbnail.enableSwatches();
  }

  // Quick shop
  if (Shopify.theme_settings.enable_quickshop) {
    Shopify.theme.thumbnail.showQuickShop();
  }

  // Currency converter
  if (Currency.show_multiple_currencies) {
    Shopify.theme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($('[data-custom-pagination]').length) {
    Shopify.theme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });

  // Tabs
  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
  }

  // Accordion
  if($('.accordion, [data-cc-accordion]').length > 0) {
    Shopify.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if($('.slider, .flexslider').length > 0) {
    Shopify.contentCreator.slideshow.init();
  }

  // Newsletter AJAX Form
  if ($('.newsletter-form__wrapper .contact-form').length > 0) {
  //     Shopify.theme.newsletterAjaxForm.init();
  }

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Flickity IOS Fix
  if (!document.querySelector('.js-tiu')) {
    Shopify.theme.flickityIosFix();
  }

  $('.mobile-menu .menu__heading').on('click', function () {
    $('.menu__heading').not(this).removeClass('active');
    $(this).toggleClass('active');
  });

  Ffheader();

  function Ffheader() {
    var FF = !(window.mozInnerScreenX == null);
    if(FF) {
      if($(window).width() <= 798) {
        $('#header').hide();
      }else {
        $('#header').show();
      }
    }
  }

  $(document).ready(function() {
    // console.log('step 0');
    // CHANGE FOR PROD
    if( ($('.product').length > 0 || $('.product-foundation').length > 0) && $('.pdp-swatch-selectors').length > 0 ) {
    // if( ($('.product').length > 0 || $('.product-teaser').length > 0) && $('.pdp-swatch-selectors').length > 0 ) {
      // console.log('step 1');
      //swatches and multiple product
      pdpSwatchDropdown('.jsProduct');
      // $('.pdp-swatch-selectors .single-option-selector').css({'width': 0, 'display': 'none', 'visibility': 'hidden'}).attr('aria-hidden', true);
    }



    // cart page samples
    var chkEl = '.fancybox-samples';
    watchForElement(chkEl,function(el) {
      // console.log('step 2');
      pdpSwatchDropdown('.fancybox-container');
    })

  })

  var SPACEBAR_KEY_CODE = [0, 32];
  var ENTER_KEY_CODE = 13;
  var DOWN_ARROW_KEY_CODE = 40;
  var UP_ARROW_KEY_CODE = 38;
  var ESCAPE_KEY_CODE = 27;

});

function pdpSwatchDropdown(selector) {
  // console.log('step 3');

  var swatchClass = selector + ' .pdp-swatch-selectors .single-option-selector';

  $(swatchClass).css({'width': 0, 'display': 'none', 'visibility': 'hidden'}).attr('aria-hidden', true);

  $('.pdp-swatch-selectors').css('visibility', 'visible');
  $.each($(swatchClass), function(index, item) {
    // console.log('step 3-1');
    var getSelectedSwatch = $(this).prop('selectedIndex') + 1;
    var parent = $(this).closest('.pdp-swatch-selectors');
    // console.log(parent.find('.selected-swatch-dd'));
    // console.log(parent.find('.dropdownwithswatch li:nth-child('+getSelectedSwatch+')'));
    // console.log(parent.find('ul.dropdownwithswatch'));
    parent.find('.selected-swatch-dd').html(parent.find('.dropdownwithswatch li:nth-child('+getSelectedSwatch+')').html());
    parent.find('.dropdownwithswatch li:nth-child('+getSelectedSwatch+')').addClass('focused').attr('aria-selected', true);
    parent.find('ul.dropdownwithswatch').attr('aria-activedescendant', 'item-'+getSelectedSwatch);

    //$('.selected-swatch-dd').html($('.dropdownwithswatch li:nth-child('+getSelectedSwatch+')').html());

    // do something with `item` (or `this` is also `item` if you like)
  });

  $(document).on('change', swatchClass, function() {
    // console.log('step 3-2');
    getSelectedSwatch = $(this).prop('selectedIndex') + 1;
    $(this).closest('.pdp-swatch-selectors').find('.selected-swatch-dd').html($('.dropdownwithswatch li:nth-child('+getSelectedSwatch+')').html());
  });

  $(document).on('click', `${selector} .selected-swatch-dd`, function(e) {
    e.preventDefault();

    // console.log('step 3-3');

    var parent = $(this).closest('.pdp-swatch-selectors');
    var _this = parent.find('.dropdownwithswatch');
    var is_open = _this.hasClass("open");
    var getSelectedSwatch = parent.find('.pdp-swatch-selectors').prop('selectedIndex') + 1;

    if (is_open) {
      _this.attr('aria-expanded', false);
      _this.removeClass("open");
    } else {
      _this.attr('aria-expanded', true);
      _this.addClass("open");
      parent.find('#listbox1 li.dropdown-list-item').removeClass('focused');
      parent.find('#listbox1').find('#item-'+getSelectedSwatch).addClass('focused');
      checkListUpDown();
    }
  });

  var checkListUpDown = function () {
    if ($('#listbox1').prop('scrollHeight') > $('#listbox1').prop('clientHeight')) {
      var scrollBottom = $('#listbox1').prop('clientHeight') + $('#listbox1').scrollTop();
      var elementBottom = $('li.dropdown-list-item.focused').prop('offsetTop') + $('li.dropdown-list-item.focused').prop('offsetHeight');
      if (elementBottom > scrollBottom) {
        $('#listbox1').scrollTop(elementBottom - $('#listbox1').height());
      } else if ($('li.dropdown-list-item.focused').prop('offsetTop') < $('#listbox1').scrollTop()) {
        $('#listbox1').scrollTop($('li.dropdown-list-item.focused').prop('offsetTop'))
      }
    }
  }

  $(document).on('keypress', '.selected-swatch-dd', function (e) {
    e.preventDefault();
    let openDropDown = SPACEBAR_KEY_CODE.includes(e.keyCode) || e.keyCode === ENTER_KEY_CODE;
    if (openDropDown) {
      var _this = $('.dropdownwithswatch');
      var parent = _this.closest('.pdp-swatch-selectors');

      var is_open = _this.hasClass("open");
      if (is_open) {
        parent.find('.selected-swatch-dd').attr('aria-expanded', false);
        _this.removeClass("open");
      } else {
        parent.find('.selected-swatch-dd').attr('aria-expanded', true);
        _this.addClass("open");
        parent.find('#listbox1 li.dropdown-list-item').removeClass('focused');
        //focus
        parent.find('#listbox1').focus();
        parent.find('#listbox1').find('#item-'+getSelectedSwatch).addClass('focused');
        checkListUpDown();
      }
    }
    if (e.keyCode === ESCAPE_KEY_CODE) {
      $('.selected-swatch-dd').attr('aria-expanded', false);
      $('.dropdownwithswatch').removeClass("open");
    }
  });

  $(document).on('click', '#listbox1', function (e) {

    if ($(e.target).closest('.swatch-element').length) {

      var swatchValue = $(e.target).closest('.swatch-element').data('value');
      $('.collection_swatches .'+swatchValue+'-swatch').trigger('click');
      $('.collection_swatches .swatch--'+swatchValue).trigger('click');
      $('.dropdownwithswatch').removeClass("open");
      $('#listbox1').attr('aria-activedescendant', $(e.target).closest('.swatch-element').attr('id'));
    }

    if ($(e.target).attr('role') === 'option') {

      var swatchValue = $(e.target).find('.swatch-element').data('value');
      $('.collection_swatches .'+swatchValue+'-swatch').trigger('click');
      $('.collection_swatches .swatch--'+swatchValue).trigger('click');
      $('.dropdownwithswatch').removeClass("open");
      $('#listbox1').attr('aria-activedescendant', $(e.target).attr('id'));
    }
  });

  $(document).on('keydown', '#listbox1', function (e) {
    if (SPACEBAR_KEY_CODE.includes(e.keyCode) || e.keyCode === ENTER_KEY_CODE) {
      $('.swatch-dd-list.dropdown-list-item.focused').click();
      $('.selected-swatch-dd').attr('aria-expanded', false);
      $('.dropdownwithswatch').removeClass("open");
    }
    if (e.keyCode === DOWN_ARROW_KEY_CODE) {
      $('.dropdownwithswatch li').attr('aria-selected', false);
      $('li.dropdown-list-item.focused').next().addClass('focused');
      $('li.dropdown-list-item.focused').prev().removeClass('focused');
      $('li.dropdown-list-item.focused').attr('aria-selected', true);
      $('ul.dropdownwithswatch').attr('aria-activedescendant', $('li.dropdown-list-item.focused').attr('id'));
      checkListUpDown();
    }
    if (e.keyCode === UP_ARROW_KEY_CODE) {
      $('li.dropdown-list-item.focused').prev().addClass('focused');
      $('li.dropdown-list-item.focused').next().removeClass('focused');
      $('li.dropdown-list-item.focused').attr('aria-selected', true);
      $('ul.dropdownwithswatch').attr('aria-activedescendant', $('li.dropdown-list-item.focused').attr('id'));
      checkListUpDown();
    }
    if (e.keyCode === ESCAPE_KEY_CODE) {
      $('.selected-swatch-dd').attr('aria-expanded', false);
      $('.dropdownwithswatch').removeClass("open");
    }
  });

  $(document).mouseup(function(event) {
    var target = event.target;
    var select = $(".dropdownwithswatch");
    if (!select.is(target) && select.has(target).length === 0) {
      select.removeClass("open");
      $('.selected-swatch-dd').attr('aria-expanded', false);
    }
  });
}


function watchForElement(el,method) {
  chkDelay = '200'; // Amount of time between Checks
  maxCheck = 100; // prevent function from running indefinitely
  checkCount = 0;
  var chkExist = setInterval(function() {
    chkClass = $(el);
    checkCount++;
    if (chkClass.length) {
      // DO something
      clearInterval(chkExist);
      method(chkClass)
    }
    if (checkCount >= maxCheck) {
      clearInterval(chkExist);
    }
  },chkDelay);
}
// var chkEl = '[data-testid="ShopifyPay-button"]';
// watchForElement(chkEl,function(el) {
//   el.parent().hide()
// })


window.addEventListener('load', function () {
  $('.product-gallery__image.flickity-active.is-selected:first-child img').addClass('lazyload');
  $('.product-gallery__thumbnails-wrapper').css({'visibility': 'visible'});
});

/*============================================================================
Slideshow arrows
==============================================================================*/


if(Shopify.theme_settings.icon_style == 'icon_solid') {
  var arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
} else {
  var arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
}
